import { createContext } from 'react';

export const defaultFeatureFlagContextValues = {
  isDarkModeEnabled: false,
  isCompanyAuthEnabled: false,
  isSelectVenueActive: false,
  isWebView: false,
  isXceedAccess: false,
  isPublicEventReportPage: false,
  testCompanyIds: '',
  externalPlatformEnabledIds: '',
  isExternalPlatformSectionEnabled: false,
  isUserResetPasswordEnabled: false,
  isOfflineSalesPassScopeEnabled: false,
};

export const FeatureFlagContext = createContext(defaultFeatureFlagContextValues);
